import SowDataContractRequestView from './SowDataContractRequestView';

export default SowDataContractRequestView;
